import type { ReactNode } from "react";
import SiteFooter from "./SiteFooter";
import SiteNav from "./SiteNav";

interface SiteLayoutProps {
  navVariant: "home" | "inner";
  footerVariant: "home" | "docs" | "legal";
  children: ReactNode;
}

function SiteLayout({ navVariant, footerVariant, children }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-amber-50/50 text-stone-800 font-sans selection:bg-amber-200">
      <SiteNav variant={navVariant} />

      {children}

      <SiteFooter variant={footerVariant} />
    </div>
  );
}

export default SiteLayout;
